import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { OptionActionInterface } from "src/app/shared/models/option-action.interface";
import { MustMatch } from "src/app/shared/validators/passwordMatch";
import { isRadiusSupportedBrand } from "src/app/shared/enum/routerBrand";
import { AppStateInterface } from "src/app/store/appState.interface";
import { loadingLocationPartnersSelector, locationPartnerCreatedSelector } from "src/app/store/locationPartner/location-partner.selectors";
import { updateFieldsSelector } from "src/app/store/settings/settings.selectors";
import { CreateLPInterface } from "src/app/shared/models/location-partners/createLP";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { CommonParamsIberis } from "src/app/shared/models/iberis/paramsForGetAll";
import { RoleEnum } from "src/app/shared/models/user/role.interface";
import {
  invokeCreateSupplierInIberis,
  resultCreateSupplier,
} from "src/app/store/suppliers/suppliers.actions";
import { ResultCreateSupplier } from "src/app/shared/models/iberis/supplier/resultCreateSupplier";
import { resultCreateSupplierSelector } from "src/app/store/suppliers/suppliers.selectors";
import { getSubCategoriesByCategory } from "src/app/store/subCategory/subCategory.actions";
import { OptionActionEnum } from "src/app/shared/data/actions-data";
import { environment } from "src/environments/environment";
import {
  createLocationPartnerSuccess,
  invokeCreateLocationPartner,
} from "src/app/store/locationPartner/location-partner.action";
import { setFileName } from "src/app/store/file/file.actions";
import { uploadFileSelector } from "src/app/store/file/file.selectors";
import {
  invokeCheckIfExistByCompanyName,
  invokeCheckIfExistByEmail,
  setCheckUserExistsByCompanyName,
  setCheckUserExistsByEmail,
} from "src/app/store/user/user.actions";
import {
  checkUserExistByCompanyNameSelector,
  checkUserExistByEmailSelector,
} from "src/app/store/user/user.selectors";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { WizardComponent } from "angular-archwizard";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { passwordValidator } from "src/app/shared/validators/password.validator";
import { emailValidator } from "src/app/shared/validators/email.validator";
import { requiredWhenValidator } from "src/app/shared/validators/required-when.validator";
import { createFranchiseSuccess, invokeCreateFranchise, invokeFranchiseFilter, invokeGetFranchiseInfoByCompanyName } from "src/app/store/franchise/franchise.action";
import { CreateFranchiseInterface } from "src/app/shared/models/franchise/createFranchise";
import { createFranchiseSuccessSelector } from "src/app/store/franchise/franchise.selectors";
import { JwtService } from "src/app/shared/services/jwt.service";
import { invokeBatchToggleFeature } from "src/app/store/features/features.actions";
import { FeatureName } from "src/app/shared/enum/feature-name.enum";
import { BatchToggleFeatureDto } from "src/app/shared/models/features/batch-toggle-feature-dto.interface";
import { initialState } from "src/app/store/franchise/franchise.reducers";
import { SubRoleEnum, SubRoleEnumMapping } from "src/app/shared/models/user/sub_role.interface";
@Component({
  selector: "app-create-location-partner",
  templateUrl: "./create-location-partner.component.html",
})
export class CreateLocationPartnerComponent
  extends BaseComponent
  implements OnInit
{
  @Input() isFranchised: boolean = false;
  @ViewChild("wizard") wizard: WizardComponent;
  locationPartnerForm: FormGroup;
  createLocationPartner$: Observable<SuccessDto | null>;
  resultCreateLocationPartner: string | null;
  createFranchiseSuccess$: Observable<SuccessDto | null>;
  resultCreateFranchise: string | null;
  update: OptionActionInterface = {
    name: [],
    icon: [],
    optionSelected: null,
    title: "",
  };
  updateFields$: Observable<OptionActionInterface | null>;
  params: CommonParamsIberis = {
    lang: "fr",
    companyId: environment.IBERIS.IBERIS_COMPANY_ID,
  };
  createSupplier: any;
  createSupplier$: Observable<ResultCreateSupplier | null>;
  supplierCreated: ResultCreateSupplier | null;
  @Input() closeModal$: Observable<boolean>;
  @Input() isFranchise: boolean | null = false;

  /** */
  @Input() selectedOption: OptionActionEnum;

  filename: string | null = null;
  uploadFile$: Observable<string | null>;

  isExistByEmail$: Observable<boolean | null>;
  isExistByCompanyName$: Observable<boolean | null>;
  isAdminLoggedIn: boolean = false;

  loading$: Observable<boolean | null>;
  loading: boolean = false;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private store: Store<AppStateInterface>,
    private translate: TranslateService,
    private toastr: ToastrService,
    private saveHistory: SaveUserHistoryService,
    private jwtService: JwtService
  ) {
    super(store);
    this.isAdminLoggedIn = this.jwtService.getRoleName(localStorage.getItem("token"))  === RoleEnum.ROLE_ADMIN;
    this.uploadFile$ = this.store
      .pipe(select(uploadFileSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.createLocationPartner$ = this.store
      .pipe(select(locationPartnerCreatedSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.createFranchiseSuccess$ = this.store
      .pipe(select(createFranchiseSuccessSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.updateFields$ = this.store
      .pipe(select(updateFieldsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.createSupplier$ = this.store
      .pipe(select(resultCreateSupplierSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.isExistByCompanyName$ = this.store
      .pipe(select(checkUserExistByCompanyNameSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.isExistByEmail$ = this.store
      .pipe(select(checkUserExistByEmailSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.loading$ = this.store  
      .pipe(select(loadingLocationPartnersSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.locationPartnerForm = this.fb.group({
      personalInformation: this.fb.group(
        {
          firstname: new FormControl(null, [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(30),
          ]),
          lastname: new FormControl(null, [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(30),
          ]),
          email: new FormControl(null, [
            Validators.required,
            emailValidator(),
          ]),
          password: new FormControl(null, [
            Validators.required,
            passwordValidator(),
            Validators.minLength(8),
            Validators.maxLength(32),
          ]),
          confirmPassword: new FormControl(null, [
            Validators.required,
            passwordValidator(),
            Validators.minLength(8),
            Validators.maxLength(32),
          ]),
          phone: [
            null,
            [Validators.required, Validators.pattern("^(?=.*?[0-9]).{8}$")],
          ],
          companyRole: new FormControl(null, [Validators.required])
        },
        {
          validator: MustMatch("password", "confirmPassword"),
        }
      ),
      companyInformation: this.fb.group({
        logo: new FormControl(null, [Validators.required]),
        companyName: new FormControl(null, [Validators.required]),
        companyAddress: new FormControl(null, [Validators.required]),
        companyActivity: new FormControl(null, [Validators.required]),
        category: new FormControl(null, [Validators.required]),
        subCategories: new FormControl(null, [Validators.required]),
        tags: new FormControl([], [Validators.required])
      }),
      locationInformation: this.fb.group({
        //address: new FormControl(null, [Validators.required]),
        latitude: new FormControl(null, [Validators.required]),
        longitude: new FormControl(null, [Validators.required]),
        zone: new FormControl(null, [Validators.required]),
        partnerStatus: new FormControl(null, [Validators.required]),
        date: new FormControl([null, null]),
        paymentFrequency: new FormControl(null),
      }),
      routerInformation: this.fb.group(
        {
          sessionTimeoutInMinutes: new FormControl(null, [Validators.required]),
          routerBrand: new FormControl(null, [Validators.required]),
          radiusEnabled: new FormControl(false),
          radUsername: new FormControl(null),
          radPassword: new FormControl(null),
        },
        {
          validators: requiredWhenValidator("radiusEnabled", ["radUsername", "radPassword"]),
        }
      ),
    });
  }
  ngOnInit(): void {
    this.loading$.subscribe((data) => {
      if (data !== null) {
        this.loading = data;
      }
    });

    if (this.isFranchised && this.isAdminLoggedIn) {
      this.locationPartnerForm.setControl(
        "personalInformation",
        this.fb.group(
          {
            franchise: new FormControl(null, [Validators.required]),
            firstname: new FormControl(null, [
              Validators.required,
              Validators.minLength(3),
              Validators.maxLength(30),
            ]),
            lastname: new FormControl(null, [
              Validators.required,
              Validators.minLength(3),
              Validators.maxLength(30),
            ]),
            email: new FormControl(null, [
              Validators.required,
              emailValidator(),
            ]),
            password: new FormControl(null, [
              Validators.required,
              Validators.pattern("^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$"),
              Validators.minLength(8),
              Validators.maxLength(32),
            ]),
            confirmPassword: new FormControl(null, [
              Validators.required,
              Validators.pattern("^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$"),
              Validators.minLength(8),
              Validators.maxLength(32),
            ]),
            phone: [
              null,
              [Validators.required, Validators.pattern("^(?=.*?[0-9]).{8}$")],
            ],
            companyRole: new FormControl(null, [Validators.required])
          },
          {
            validator: MustMatch("password", "confirmPassword"),
          }
        ),
      );
    }
    if (!this.isAdminLoggedIn) {
      this.locationPartnerForm.setControl(
        "locationInformation",
        this.fb.group(
          {
            latitude: new FormControl(null, [Validators.required]),
            longitude: new FormControl(null, [Validators.required]),
            zone: new FormControl(null, [Validators.required])
          }
        )
      );
      this.locationPartnerForm.setControl(
        "remuneration",
        this.fb.group(
          {
            isActive: new FormControl(null, [Validators.required])
          }
        )
      );
    }
    this.isExistByEmail$.subscribe((data) => {
      if (data == false) {
        this.wizard.goToNextStep();
      }
      if (data) {
        this.toastr.error(
          this.translate.instant("response.error.email-exist"),
          this.translate.instant("response.errorTitle")
        );
      }
      this.store.dispatch(setCheckUserExistsByEmail({ isExist: null }));
    });
    this.isExistByCompanyName$.subscribe((data) => {
      if (data == false) {
        if (this.isFranchise) {
          this.createNewUser(RoleEnum.ROLE_FRANCHISE);
        }
        else {
          this.wizard.goToNextStep();
        }
      }
      this.store.dispatch(
        setCheckUserExistsByCompanyName({ isExistByCompanyName: null })
      );
    });
    this.uploadFile$.subscribe((result: string | null) => {
      if (result != null) {
        this.filename = result;
        this.store.dispatch(setFileName({ filename: null }));
      }
    });
    this.store.dispatch(
      getSubCategoriesByCategory({ subCategoriesByCategoryName: null })
    );

    this.createLocationPartner$.subscribe((result: SuccessDto | null) => {
      if (result != null) {
        this.resultCreateLocationPartner = result.message;
        this.store.dispatch(
          createLocationPartnerSuccess({ successMessage: null })
        );
        if (this.isFranchised && this.isAdminLoggedIn) {
          this.store.dispatch(
            invokeFranchiseFilter(
              {
                franchiseFilter: initialState.franchiseFilter,
            })
          );
        }
        if (!this.isAdminLoggedIn && this.locationPartnerForm.get('remuneration.isActive')?.value) {
          const payload: BatchToggleFeatureDto = {
            userEmail: this.locationPartnerForm.get('personalInformation.email')?.value,
            elements: [{
              enable: this.locationPartnerForm.get('remuneration.isActive')?.value,
              featureName: FeatureName.REMUNERATION
            }]
          }
          this.store.dispatch(
            invokeBatchToggleFeature({payload})
          );
        }
      }
    });

    this.createFranchiseSuccess$.subscribe((result: SuccessDto | null) => {
      if (result != null) {
        this.toastr.success(
          this.translate.instant("response.success." + result.message),
          this.translate.instant("response.successTitle")
        );
        this.store.dispatch(createFranchiseSuccess({ successMessage: null }));
        this.store.dispatch(
          invokeFranchiseFilter(
            {
              franchiseFilter: initialState.franchiseFilter,
          })
        );
        this.modalService.dismissAll();
      }
    });

    this.updateFields$.subscribe((result) => {
      if (result) {
        this.update = result;
      }
    });
    this.createSupplier$.subscribe((result: ResultCreateSupplier | null) => {
      if(result){
        if (result?.status.code === 200) {
          this.createNewUser(RoleEnum.ROLE_LOCATION, result);
          this.saveHistory.saveUserHistory(
            UserHistoryActionsEnum.POST,
            UserHistoryServicesEnum.CREATE_LOCATIONS
          );
          const modal = this.modalService.dismissAll(
            CreateLocationPartnerComponent
          );
        }else{
          this.toastr.error(
            this.translate.instant("response.error.BILLING_SERVICE_FAILED"),
            this.translate.instant("response.errorTitle")
          );
          this.modalService.dismissAll();
        }
        this.store.dispatch(
          resultCreateSupplier({ resultCreateSupplier: null })
        );
      }
    });
  }
  createNewUser(role: RoleEnum, iberisResult?: ResultCreateSupplier) {
    if (role === RoleEnum.ROLE_LOCATION) {
      // RADIUS credentials are only sent when the brand supports RADIUS and it is enabled; otherwise they are cleared.
      const radiusEnabled =
        isRadiusSupportedBrand(this.locationPartnerForm.get("routerInformation.routerBrand")?.value) &&
        this.locationPartnerForm.get("routerInformation.radiusEnabled")?.value === true;
      let location: CreateLPInterface = {
        franchise: this.locationPartnerForm.get(
          "personalInformation.franchise"
        )?.value,
        firstName: this.locationPartnerForm.get(
          "personalInformation.firstname"
        )?.value,
        lastName: this.locationPartnerForm.get("personalInformation.lastname")
          ?.value,
        email: this.locationPartnerForm.get("personalInformation.email")
          ?.value.toLowerCase(),
        password: this.locationPartnerForm.get("personalInformation.password")
          ?.value,
        companyActivity: this.locationPartnerForm.get(
          "companyInformation.companyActivity"
        )?.value,
        companyAddress: this.locationPartnerForm.get(
          "companyInformation.companyAddress"
        )?.value,
        companyName: this.locationPartnerForm.get(
          "companyInformation.companyName"
        )?.value,
        phone: this.locationPartnerForm.get("personalInformation.phone")
          ?.value,

        latitude: this.locationPartnerForm.get("locationInformation.latitude")
          ?.value,
        longitude: this.locationPartnerForm.get(
          "locationInformation.longitude"
        )?.value,
        zoneName: this.locationPartnerForm.get("locationInformation.zone")
          ?.value,
        partnerStatus: this.locationPartnerForm.get(
          "locationInformation.partnerStatus"
        )?.value,
        paymentFrequency: this.locationPartnerForm.get(
          "locationInformation.paymentFrequency"
        )?.value,
        pilotPhaseStartDate:
          this.locationPartnerForm.get("locationInformation.date")
            ?.value[0] ?? null,
        pilotPhaseEndDate:
          this.locationPartnerForm.get("locationInformation.date")
            ?.value[1] ?? null,
        subCategories: this.locationPartnerForm.get(
          "companyInformation.subCategories"
        )?.value,
        tags: this.locationPartnerForm.get("companyInformation.tags")
          ?.value,
        logo: this.filename ?? this.locationPartnerForm.get("companyInformation.logo")?.value,
        price: 0,
        roleName: RoleEnum.ROLE_LOCATION,
        subRole: this.locationPartnerForm.get(
          "personalInformation.franchise"
        )?.value ? SubRoleEnumMapping[SubRoleEnum.FRANCHISED] : SubRoleEnumMapping[SubRoleEnum.LOCATION_MANAGER],
        iberis: iberisResult!.data.provider.hashed_id,
        companyRole: this.locationPartnerForm.get(
          "personalInformation.companyRole"
        )?.value,
        routerBrand : this.locationPartnerForm.get("routerInformation.routerBrand")?.value,
        sessionTimeoutInMinutes : this.locationPartnerForm.get("routerInformation.sessionTimeoutInMinutes")?.value,
        radiusEnabled,
        radUsername: radiusEnabled ? this.locationPartnerForm.get("routerInformation.radUsername")?.value : null,
        radPassword: radiusEnabled ? this.locationPartnerForm.get("routerInformation.radPassword")?.value : null
      };
      this.store.dispatch(
        invokeCreateLocationPartner({ createLocationPartner: location })
      );
    }

    if (role === RoleEnum.ROLE_FRANCHISE) {
      let franchise: CreateFranchiseInterface = {
        firstName: this.locationPartnerForm.get(
          "personalInformation.firstname"
        )?.value,
        lastName: this.locationPartnerForm.get("personalInformation.lastname")
          ?.value,
        email: this.locationPartnerForm.get("personalInformation.email")
          ?.value.toLowerCase(),
        password: this.locationPartnerForm.get("personalInformation.password")
          ?.value,
        companyActivity: this.locationPartnerForm.get(
          "companyInformation.companyActivity"
        )?.value,
        companyAddress: this.locationPartnerForm.get(
          "companyInformation.companyAddress"
        )?.value,
        companyName: this.locationPartnerForm.get(
          "companyInformation.companyName"
        )?.value,
        phone: this.locationPartnerForm.get("personalInformation.phone")
          ?.value,
        subCategories: this.locationPartnerForm.get(
          "companyInformation.subCategories"
        )?.value,
        tags: this.locationPartnerForm.get("companyInformation.tags")
          ?.value,
        logo: this.filename ?? this.locationPartnerForm.get("companyInformation.logo")?.value,
        roleName: RoleEnum.ROLE_FRANCHISE,
        subRole:  SubRoleEnumMapping[SubRoleEnum.FRANCHISE_MANAGER],
        companyRole: this.locationPartnerForm.get(
          "personalInformation.companyRole"
        )?.value
      };
      this.store.dispatch(
        invokeCreateFranchise({ createFranchise: franchise })
      );
    }
  }

  onClickDismissAll() {
    this.modalService.dismissAll();
  }
  clearForm() {
    this.locationPartnerForm.reset();
    this.modalService.dismissAll();
  }
  submit() {
    this.loading = true
    if (this.isFranchise) {
      this.verifyCompanyName();
    }
    else {
      this.createSupplier = {
        email: this.locationPartnerForm.get("personalInformation.email")?.value.toLowerCase(),
        first_name: this.locationPartnerForm.get("personalInformation.firstname")
          ?.value,
        last_name: this.locationPartnerForm.get("personalInformation.lastname")
          ?.value,
        company: this.locationPartnerForm.get("companyInformation.companyName")
          ?.value,
        display_name: 2,
        phone: this.locationPartnerForm.get("personalInformation.phone")?.value,
        activity_id: this.locationPartnerForm.get(
          "companyInformation.companyActivity"
        )?.value,
        currency_id: "rorJ",
        title: 1,
        price_list_id: environment.IBERIS.PRICE_ID,
        deadline_id: environment.IBERIS.DEADLINE_ID,
      };
      this.store.dispatch(
        invokeCreateSupplierInIberis({
          params: this.params,
          createSupplier: this.createSupplier,
        })
      );
    }
  }
  verifyEmail() {
    this.store.dispatch(
      invokeCheckIfExistByEmail({
        email: this.locationPartnerForm
          .get("personalInformation.email")
          ?.value.toLowerCase(),
      })
    );
    if (this.isFranchised) {
      const companyName: string = 
        this.isAdminLoggedIn 
        ? 
        this.locationPartnerForm.get("personalInformation.franchise")?.value
        :
        this.jwtService.getCompanyName();

      this.store.dispatch(
        invokeGetFranchiseInfoByCompanyName({
          companyName
        })
      );
    }
  }
  verifyCompanyName() {
    this.store.dispatch(
      invokeCheckIfExistByCompanyName({
        companyName: this.locationPartnerForm.get(
          "companyInformation.companyName"
        )?.value,
      })
    );
  }
  showModal(simpleContent: TemplateRef<any>) {
    const modalRef = this.modalService.open(simpleContent);
  }
}
